import React from 'react'
import graphql from 'graphql'
import get from 'lodash/get'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
import Header from '../components/header'
import Footer from '../components/footer'
import styles from './contact.module.css'
import favicon64 from "../images/favicon64.png";
import favicon32 from "../images/favicon32.png";
import favicon16 from "../images/favicon16.png";

class contact extends React.Component {
  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    /* const post = get(this, 'props.data.allContentfulContact.edges') */
    /* console.log('data:',this.props.data.contentfulContact.pageTitle) */

    const { pageTitle, pageImage, contactLongText, myLocation } = this.props.data.contentfulContact;

    return (
      <div style={{ background: '#fff' }}>
        <Helmet
            title={siteTitle}
            meta={[
              {
                name: "keywords",
                content: "frontend, developer, photography, blog, travell blog",
              },
            ]}
            link={[
              { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon16}` },
              { rel: "icon", type: "image/png", sizes: "32x32", href: `${favicon32}` },
              { rel: "shortcut icon", type: "image/png", href: `${favicon64}` },
            ]}
          />
        <Header />
        <div className={styles.hero}>
          <h1>{pageTitle}</h1>
        </div>
        {/*  <div className="contactBanner">            
            <Img  sizes={pageImage.resolutions} />            
          </div> */}
        <div className={styles.contactContent}>
          <div dangerouslySetInnerHTML={{
            __html: contactLongText.childMarkdownRemark.html,
          }} />
        </div>
        <div className={styles.contactForm}>
          <form name="contact" method="post" action="/thanks/" data-netlify="true" data-netlify-honeypot="bot-field">
            <input type="hidden" name="form-name" value="contact" />
              <p hidden>
                <label>Don’t fill this out:<input name="bot-field" /></label>
              </p>
              <p>
                <label>Your name:<br/><input type="text" name="name" /></label>
              </p>
              <p>
                <label>Your email:<br/><input type="email" name="email"/></label>
              </p>
              <p>
                <label>Message:<br/><textarea name="message"></textarea></label>
              </p>
              <p>
                <button type="submit">Send</button>
              </p>
          </form>
        </div>
            <div className={styles.mapStyle}>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d235013.70718479907!2d72.439658281228!3d23.020497766666384!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e848aba5bd449%3A0x4fcedd11614f6516!2sAhmedabad%2C+Gujarat!5e0!3m2!1sen!2sin!4v1565775804869!5m2!1sen!2sin"></iframe>
              {/*   <span>{myLocation.lon}</span> <br/>
          <span>{myLocation.lat}</span> */}
            </div>
            <Footer />
      </div>
            )
          }
        }
        
        export default contact
        
        export const pageQuery = graphql`
  query ContactIndexQuery {
              contentfulContact {
            pageImage {
              resolutions(width: 1600) {
              width
          height
            src
            srcSet
          }
        }
        pageTitle
      contactLongText {
              childMarkdownRemark {
            html
          }
        }
      myLocation {
              lon
        lat
            }
          }
        }
  `


// WEBPACK FOOTER //
// ./src/pages/contact.js